<xware-login-background>
  <div *ngIf="!logout" login-card class="login-div">
    <div>
      <img src="assets/images/CrosswareLogoCol.svg" alt="Crossware Logo" class="login-img" />
      <p class="login-desc">Crossware Me</p>
    </div>

    <div class="btn-container">
      <div
        *ngIf="bShowAzure"
        id="btnLoginM"
        (click)="signInAzure()"
        class="pointer ms-btn sign-in-div"
        data-test="sign-in-btn"
      >
        <img src="assets/images/ms_logo.svg" alt="" class="ms-btn-icon" />
        <span class="ms-btn-text">Sign in with Microsoft</span>
      </div>

      <div *ngIf="bShowGoogle" class="google-btn">
        <div id="btnLoginG" class="btn-login-div"></div>
      </div>
    </div>
  </div>

  <div *ngIf="logout" login-card class="login-div logout-div">
    <span tabindex="0" class="signInEnter">Signing out...</span>
  </div>

  <div login-footer class="txt-version">&copy; Crossware 2026 &middot; v{{ designerVersion }}</div>
</xware-login-background>
